import { render } from "./PaymentView.vue?vue&type=template&id=4522f16e&scoped=true"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"

import "./PaymentView.vue?vue&type=style&index=0&id=4522f16e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4522f16e"]])

export default __exports__